/**
 * Titles of the workflow editor's accordion sections, each naming WHAT it is showing.
 *
 * Ajuste PO 2026-07-27: the sections were titled by their kind alone, so nothing on screen said
 * which thing they applied to — a subworkflow dialog just said "Subworkflow" (the header fields
 * above it are the SUBworkflow's own code/name, not its parent's), and the selected job's section
 * just said "Tasks". The relevant code+name is appended to the title, using the same
 * `formatCodeName` convention every other code+name label in the module follows (RN01.4/RN01.6: an
 * empty name renders as nothing and is never substituted by the code).
 *
 * Lives in its own module — not in `utils.js` — because that file transitively pulls in the
 * ESM-only `uuid` package, which CRA's Jest does not transform.
 */

import { formatCodeName } from '../../generic/utilities/objectStructures/codeNameFormat'

/**
 * @param {string} title The already translated section title ("Subworkflow", "General Properties", ...)
 * @param {string} code Code of what the section is showing, '' when there is nothing to name
 * @param {string} name Its free descriptive name, '' when it has none
 * @returns {string}
 */
const buildWorkflowSectionTitle = (title, code = '', name = '') => {
  const identity = formatCodeName(code, name).trim()
  return identity ? `${title} - ${identity}` : title
}

export { buildWorkflowSectionTitle }
